import { ref } from 'vue';

const getDashletDatas = () => {
    const dashletDatas_error = ref(null);
    const dashletDatas = ref(null);

    const loadDashletDatas = async (team_id,employer_id, location_id, division_id, date_filter_option_id, to_Date, dashlet_type ) => {
      try {
        var params = [];

        if (to_Date) {
          params.push(['comparingDashlet', false]);
          params.push(['date', to_Date]);
          params.push(['teamId', team_id]);
          params.push(['employerId', employer_id]);
          params.push(['locationId', location_id]);
          params.push(['divisionId', division_id]);
          params.push(['datefilter', date_filter_option_id]);
          params.push(['dashletType', dashlet_type]);
        }
        //console.log("getDashlet.js API Sub: ", dashlet_type);
        //console.log("getDashlet.js API Sub: ", "/api/stats/" + dashlet_type + "?");
        
        //let data = await fetch("/api/stats/" + dashlet_type + "?" + new URLSearchParams(params));

        let data = await fetch("/api/statistics/data?" + new URLSearchParams(params));

        if (!data.ok) {
          throw Error("Can't load data");
        }

        dashletDatas.value = await data.json();

      //console.log("getDashlet.js: ", dashletDatas.value);
      } catch (err) {
        dashletDatas_error.value = err.message;
        console.log("getDashletDatas.js Error: ", dashletDatas_error.value);
      }
    };

    return { dashletDatas, dashletDatas_error, loadDashletDatas};
}

export default getDashletDatas;
